export default __webpack_public_path__ + "static/media/ic.f798f243.png";